import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-5 pr-5 pb-5 overflow-auto h-screen" }

import axios from "axios";
import { format, parseISO } from "date-fns";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import GalleryContentImages from "shared/components/camera/GalleryContentImages.vue";
import LogoWatermark from "shared/components/other/LogoWatermark.vue";
import { useCustomToast } from "shared/composables/toast";
import CameraRepository from "shared/repositories/CameraRepository";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import logger from "shared/services/logger";
import { GalleryImagesPaginatedResponse } from "shared/types/Camera";


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryView',
  setup(__props) {

const data = ref<GalleryImagesPaginatedResponse | null>(null);
const date = ref<Date | null>(null);
const loading = ref(false);
const showDefaultImages = ref(false);

const { t } = useI18n();
const route = useRoute();
const toast = useCustomToast();

onMounted(() => {
  getGalleryImages(dateToString.value);
});

const dateToString = computed(() => (date.value ? format(date.value, "yyyy-MM-dd") : ""));

const getGalleryImages = async (value: string | null | undefined) => {
  try {
    date.value = value ? parseISO(value) : null;
    loading.value = true;

    const { customer_name, site_id, camera_id } = route.params;

    data.value = await CameraRepository.getPaginatedGalleryImages(
      customer_name as string,
      site_id as string,
      camera_id as string,
      value || null,
    );
    date.value = new Date(data.value.date);
    showDefaultImages.value = false;

    data.value.items.forEach((img) => {
      const imgElement = new Image();
      imgElement.src = img.url;
      imgElement.addEventListener("load", () => {
        img.width = imgElement.naturalWidth;
        img.height = imgElement.naturalHeight;
      });
    });

    loading.value = false;
  } catch (error) {
    const is404 = axios.isAxiosError(error) && error.response?.status === 404;
    if (!PublicTokenRepository.isPublicTokenAuthError(error) && !is404) {
      logger.error(error);
    }
    data.value = null;
    toast.error(
      t(
        PublicTokenRepository.isPublicTokenAuthError(error)
          ? "public_tokens.link_expired"
          : "err.no_data_found",
      ),
    );
    showDefaultImages.value = true;
    loading.value = false;
    loading.value = false;
  } finally {
    loading.value = false;
  }
};

const handleDateChange = (date: string | null) => {
  getGalleryImages(date);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(GalleryContentImages, {
        enableHeaderDateField: true,
        date: date.value,
        data: data.value,
        loading: loading.value,
        showDefaultImages: showDefaultImages.value,
        cameraId: _unref(route).params.camera_id as string,
        onDateChange: handleDateChange
      }, null, 8, ["date", "data", "loading", "showDefaultImages", "cameraId"])
    ]),
    _createVNode(LogoWatermark, { class: "fixed top-2 right-[24px]" })
  ], 64))
}
}

})